/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, {useEffect, Fragment, useState} from "react";
import {cloneDeep} from "lodash";
import {Card, CardHeader, Col, CardBody, ListGroup, ListGroupItem, Row} from "reactstrap";
import {FaCog, FaEdit} from "react-icons/fa";
import {useDispatch, useSelector} from "react-redux";
import {useParams} from "react-router-dom";
import ClaimController from "../../components/Modal/ClaimController";
import CommonHeader from "../../components/Headers/CommonHeader";
import ProtectedContent, {usePermissionCheck} from "../../components/protectedContent";
import Tabs from "../../components/Tabs/Tabs";
import SafeView from "../../components/safeView/SafeView";
import {useDisclosure} from "../../hooks/useDisclosure";
import {
  getCurrentSite,
  getLocations,
  getSelectedLocations,
} from "../../redux/Selectors/sites.selectors";
import {
  requestLocations,
  updateSelectedLocation,
} from "../../redux/Actions/sites.actions";
import {requestControllers} from "../../redux/Actions/controllers.actions";
import "./sites.scss";
import CreateSite from "../../components/Modal/CreateSite";
import useGetTabList from "./useGetTabList";

const SitesContainer = () => {
  const dispatch = useDispatch();
  const {
    isOpen: isClaimModalOpen,
    onOpen: openClaimModal,
    onClose: closeClaimModal,
  } = useDisclosure();
  const {
    isOpen: isSiteModalOpen,
    onOpen: openSiteModal,
    onClose: closeSiteModal,
  } = useDisclosure();
  const {tabList} = useGetTabList();
  const {siteId} = useParams();
  const canViewInventory = usePermissionCheck(["view_systeminventory"]);
  const canViewLocations = usePermissionCheck(["view_location"]);
  const currentSite = useSelector(getCurrentSite);
  const locations = useSelector(getLocations);
  const selectedLocation = useSelector(getSelectedLocations);
  const [type, setType] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);

  const {name = "", is_active} = currentSite || {};

  useEffect(() => {
    if (canViewLocations) {
      dispatch(requestLocations(siteId));
    }
    // dispatch(updateSelectedLocation());
  }, [canViewLocations, dispatch, siteId]);

  const handleSiteFormOpen = (type, data) => {
    setType(type);
    if (data && data.id) {
      const newData = cloneDeep({
        ...data,
        users:
          data.users?.map((user) => (typeof user === "object" ? user?.value : user)) ||
          [],
      });
      setSelectedItem(newData);
    } else {
      setSelectedItem(null);
    }
    openSiteModal();
  };

  const handleSiteModalClose = () => {
    setType(null);
    setSelectedItem(null);
    closeSiteModal();
  };

  const handleLocationClickTab = (data) => {
    dispatch(updateSelectedLocation(data));
    if (canViewInventory) {
      dispatch(requestControllers());
    }
  };

  return (
    <Fragment>
      {isSiteModalOpen && (
        <CreateSite
          data={selectedItem}
          onClose={handleSiteModalClose}
          open={isSiteModalOpen}
          type={type}
        />
      )}
      {isClaimModalOpen && (
        <ClaimController open={isClaimModalOpen} onCancel={closeClaimModal} />
      )}
      <SafeView>
        <ProtectedContent perms={["add_systeminventory"]}>
          <CommonHeader content={"Claim Appliance"} handleAddClick={openClaimModal} />
        </ProtectedContent>
        <Row className="site-main">
          <Col xl="3" className="site--second">
            <Card className="shadow">
              <CardHeader className="border-0">
                <Row className="align-items-center">
                  <div className="col">
                    <h3 className="mb-0">{name}</h3>
                  </div>
                  <ProtectedContent perms={["change_site"]}>
                    <div className="col text-right site--edit">
                      <FaCog
                        onClick={() => handleSiteFormOpen("site", currentSite)}
                        data-cy="Setting"
                      />
                    </div>
                  </ProtectedContent>
                </Row>
              </CardHeader>
              <CardBody style={{padding: "0px"}}>
                <ListGroup style={{margin: "0px"}}>
                  {is_active && (
                    <ProtectedContent perms={["add_location"]}>
                      <ListGroupItem
                        style={{cursor: "pointer", borderRadius: "0px"}}
                        onClick={() => handleSiteFormOpen("location")}
                        data-cy="add_location"
                        action
                        tag="a"
                      >
                        {"Add Location"}
                      </ListGroupItem>
                    </ProtectedContent>
                  )}
                  <ProtectedContent perms={["view_location"]}>
                    <Fragment>
                      {locations.map((location) => {
                        const isActive =
                          selectedLocation && selectedLocation.id === location.id;
                        return (
                          <ListGroupItem
                            className={`location-item ${
                              isActive ? "active-location-item" : ""
                            }`}
                            key={location.id}
                            action
                            tag="a"
                            active={isActive}
                            data-cy="select_location"
                          >
                            <div
                              className="location-name"
                              onClick={() => handleLocationClickTab(location)}
                            >
                              {location.name}{" "}
                            </div>
                            {
                              <ProtectedContent perms={["change_location"]}>
                                <FaEdit
                                  className="float-right"
                                  fontSize={20}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleSiteFormOpen("location", location);
                                  }}
                                  data-cy="edit_location"
                                />
                              </ProtectedContent>
                            }
                          </ListGroupItem>
                        );
                      })}
                    </Fragment>
                  </ProtectedContent>
                </ListGroup>
              </CardBody>
            </Card>
          </Col>
          <Col className="mb-5 mb-xl-0" xl="9">
            <Card className="shadow">
              {
                <Tabs
                  list={tabList}
                  defaultActive={tabList[0]?.key}
                  key={tabList[0]?.key}
                  selectedLocation={{}}
                />
              }
            </Card>
          </Col>
        </Row>
      </SafeView>
    </Fragment>
  );
};

export default SitesContainer;
